import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BottomNavbarComponent, PageLayoutComponent, TitileNavbarComponent } from '@ui-components';
import { userTrophiesMapper, UserTrophyModel } from '@core';
import { AppTrophyType } from '@core-http';
import { GetMyTrophyTypesQueryHandler } from '../../application/handlers';

@Component({
  selector: 'lib-all-trophies',
  templateUrl: './all-trophies.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TitileNavbarComponent, BottomNavbarComponent, PageLayoutComponent],
  providers: [GetMyTrophyTypesQueryHandler]
})
export class AllTrophiesComponent {
  private readonly getMyTrophyTypesQueryHandler: GetMyTrophyTypesQueryHandler = inject(GetMyTrophyTypesQueryHandler);

  private readonly allTrophies: AppTrophyType[] = Object.values(AppTrophyType);
  readonly trophiesMapper: Record<AppTrophyType, UserTrophyModel> = userTrophiesMapper;

  private readonly earnedTypes: Signal<AppTrophyType[]> = toSignal(this.getMyTrophyTypesQueryHandler.getEarnedTypes(), {
    initialValue: []
  });

  readonly earnedTrophies: Signal<AppTrophyType[]> = computed(() => this.earnedTypes());
  readonly availableTrophies: Signal<AppTrophyType[]> = computed(() =>
    this.allTrophies.filter((trophy: AppTrophyType) => !this.earnedTypes().includes(trophy))
  );
}
